import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@curves/ui-base';
import { useHistory, useLocation } from 'react-router-dom';
import { useMainLayoutContext } from '@Local/Components/Layout/Context/MainLaydoutContext';
import { FOOTER_TYPE, HEADER_TYPE, THEME_TYPE } from '@Constants/dataEnums';
import { MEMBER_CYCLE_PURCHASE_ROUTER } from '@Router/routerPath';
import { CyclePurchaseStepper } from '@Local/CyclePurchase/Components';

/**
 * 循環訂單變更成功頁
 * 顯示生效方式（立即 / 下一期）、日期資訊與變更後商品摘要。
 * 入口：CyclePurchaseConfirmPage → handleConfirm（location.state: { cartSummary, effectType, effectDate, nextShipDate }）
 */
const CyclePurchaseSuccessPage = () => {
    const { setHeaderType, setFooterType, setThemeType, setHeaderContent } = useMainLayoutContext();
    const history = useHistory();
    const location = useLocation();
    const { cartSummary = [], effectType, effectDate, nextShipDate } = location.state || {};

    // 功能：設定版面
    useEffect(() => {
        setHeaderType(HEADER_TYPE.LOGO_CENTER);
        setFooterType(FOOTER_TYPE.HIDE);
        setThemeType(THEME_TYPE.DARK);
        setHeaderContent(<CyclePurchaseStepper activeStep={2} />);

        return () => setHeaderContent(null);
    }, [setHeaderType, setFooterType, setThemeType, setHeaderContent]);

    // 功能：生效方式文字（API 回傳 effectTimingText 為 "immediate" 或 "next"）
    const effectLabel = effectType === 'immediate' ? '已立即生效' : '將於下一期生效';

    return (
        <Box className="cycle-purchase-success-page">
            <Box className="cp-success-content">
                {/* 成功圖示 */}
                <Box className="cp-success-icon-wrap">
                    <Typography className="cp-success-icon">✓</Typography>
                </Box>

                <Typography className="cp-success-title">變更成功</Typography>
                <Typography className="cp-success-effect">{effectLabel}</Typography>

                {/* 日期資訊：立即生效只顯示下次出貨日；下一期生效顯示生效日與預計出貨日 */}
                {effectType === 'immediate' ? (
                    nextShipDate && (
                        <Typography className="cp-success-date">
                            下次出貨日：<span className="cp-success-date-value">{nextShipDate}</span>
                        </Typography>
                    )
                ) : (
                    <>
                        {effectDate && (
                            <Typography className="cp-success-date">
                                生效日：<span className="cp-success-date-value">{effectDate}</span>
                            </Typography>
                        )}
                        {nextShipDate && (
                            <Typography className="cp-success-date">
                                預計出貨日：<span className="cp-success-date-value">{nextShipDate}</span>
                            </Typography>
                        )}
                    </>
                )}

                {/* 變更後商品摘要 */}
                {cartSummary.length > 0 && (
                    <Box className="cp-success-items">
                        {cartSummary.map((item) => (
                            <Typography key={item.productID} className="cp-success-item">
                                {item.productName} x{item.quantity}
                            </Typography>
                        ))}
                    </Box>
                )}

                <Button
                    variant="contained"
                    fullWidth
                    onClick={() => history.replace(MEMBER_CYCLE_PURCHASE_ROUTER)}
                    className="cp-success-back-btn"
                >
                    返回訂單列表
                </Button>
            </Box>
        </Box>
    );
};

export default CyclePurchaseSuccessPage;
